<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

defineProps<{
  to?: RouteLocationRaw
  icon?: string
}>()
</script>

<template>
  <NButton
    n="borderless"
    v-bind="$props"
    class="w-full rounded-md fw600 hover:bg-slate-50"
  >
    <slot />
  </NButton>
</template>
